<template>
    <div class="automation-trigger-settings">
        <p>
            {{ t('automations-form-triggers_config-custom_event-description') }}
        </p>

        <div class="field">
            <label
                :class="{
                    label: true,
                    'label-danger': !isFieldValid('filterEvent'),
                }"
                >{{ t('automations-form-triggers_config-custom_event-event_label') }}
            </label>
            <kv-search-select
                :placeholder="t('automations-form-triggers_config-custom_event-event_placeholder')"
                api-endpoint="custom-event/events"
                display-field="title"
                value-field="id"
                v-model="filterEvent"
                icon-class="far fa-calendar"
                :min-search-length="1"
                @select="onEventSelected"
            />
        </div>

        <div class="field" v-show="!!filterEvent">
                    <label
                        :class="{
                            label: true,
                            'label-danger': !isFieldValid('filterType'),
                        }"
                        >{{ t('automations-form-triggers_config-custom_event-when_label') }}
                    </label>
                    <select v-model="filterType" class="form-control">
                        <option value="all">{{ t('automations-form-triggers_config-custom_event-when_options-all') }}</option>
                        <option value="every">{{ t('automations-form-triggers_config-custom_event-when_options-every') }}</option>
                        <option value="exact">{{ t('automations-form-triggers_config-custom_event-when_options-exact') }}</option>
                    </select>
        </div>

        <div class="field" v-if="!!filterEvent && filterType !== 'all'">
                    <label
                        :class="{
                            label: true,
                            'label-danger': !isFieldValid('filter'),
                        }"
                        >{{ t('automations-form-triggers_config-custom_event-x_label') }}
                    </label>
                    <small v-if="filterType === 'every'">
                        {{ t('automations-form-triggers_config-custom_event-every_help') }}
                    </small>
                    <small v-if="filterType === 'exact'">
                        {{ t('automations-form-triggers_config-custom_event-exact_help') }}
                    </small>
                    <input type="tel" v-model="filter" class="form-control" />
        </div>
    </div>
</template>
<style lang="less">
.filter-value {
    .row.inputs {
        margin-top: 10px;
    }
    input {
        margin-top: 4px;
    }
}
</style>
<script>
import keviApi from "../../../keviApi";
import KvSearchSelect from "../../../components/ui/kv-search-select.vue";

export default {
    components: {
        KvSearchSelect
    },
    props: {
        value: {
            type: Array,
            default: [],
        },
    },
    data: function () {
        let filterType =
            this.value.length > 0 && this.value[0].filterType
                ? this.value[0].filterType
                : "all";
        let filter =
            this.value.length > 0 && this.value[0].filter
                ? parseInt(this.value[0].filter)
                : null;
        let filterEvent =
            this.value.length > 0 && this.value[0].filterEvent
                ? this.value[0].filterEvent
                : false;
        return {
            filterType: filterType,
            filter: filter,
            filterEvent: filterEvent,
        };
    },
    computed: {
        errors() {
            let errors = {};

            if (!this.filterType) {
                errors["filterType"] = "empty";
            }

            const numberFilterTypes = ["every", "exact"];
            if (
                numberFilterTypes.includes(this.filterType) &&
                !parseInt(this.filter)
            ) {
                errors["filter"] = "invalid";
            }

            if (!this.filterEvent) {
                errors["filterEvent"] = "empty";
            }
            return errors;
        },
        floatMax() {
            return this.float(this.maxValue);
        },
    },
    mounted: function () {
        window.setTimeout(() => {
            this.changed();
        }, 100);
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        isFieldValid(field) {
            return !Object.keys(this.errors).includes(field);
        },
        isValid: function () {
            return Object.keys(this.errors).length === 0;
        },
        onEventSelected(event) {
            this.filterEvent = event.id;
        },
        changed: function () {
            this.$emit("input", [
                {
                    filter: this.filter,
                    filterType: this.filterType,
                    filterEvent: this.filterEvent,
                },
            ]);
        },
    },
    watch: {
        filterType: function () {
            this.changed();
        },
        filter: function () {
            this.changed();
        },
        filterEvent: function () {
            this.changed();
        },
        value: function () {
            let filterType =
                this.value.length > 0 && this.value[0].filterType
                    ? this.value[0].filterType
                    : "all";
            let filter =
                this.value.length > 0 && this.value[0].filter
                    ? parseInt(this.value[0].filter)
                    : null;
            let filterEvent =
                this.value.length > 0 && this.value[0].filterEvent
                    ? this.value[0].filterEvent
                    : false;

            if (filter !== this.filter) {
                this.filter = filter;
            }

            if (filterType !== this.filterType) {
                this.filterType = filterType;
            }

            if (filterEvent !== this.filterEvent) {
                this.filterEvent = filterEvent;
            }
        },
    },
};
</script>
